import dayjs from '../../../../helpers/dates';
import { formatCurrencyOnBlur } from '../../../../helpers/utils';

export default [
  { label: 'Fiscal Year Start', name: 'fiscal_year_start', type: 'date' },
  {
    label: `Current Budget (${dayjs().year()})`,
    name: 'current_budget',
    type: 'money',
    transformOnBlur: formatCurrencyOnBlur,
  },
  {
    label: `Prior Budget (${dayjs().subtract(1, 'year').year()})`,
    name: 'prior_budget',
    type: 'money',
    transformOnBlur: formatCurrencyOnBlur,
  },
  {
    label: `Next Year Budget (${dayjs().add(1, 'year').year()})`,
    name: 'future_budget',
    type: 'money',
    transformOnBlur: formatCurrencyOnBlur,
  },
  { label: 'Most Recent Audit', name: 'recent_audit', type: 'date' },
  { label: 'Most Recent 990', name: 'recent_990', type: 'date' },
  {
    label: 'Insurance Description and Amounts',
    name: 'insurance_desc',
    multiline: true,
  },
  {
    label: 'Endowment Amounts and Where Held',
    name: 'endowments',
    multiline: true,
  },
  {
    label: 'Notes',
    name: 'notes',
    multiline: true,
  },
  { label: 'Expiration Date', name: 'expires', type: 'date' },
];
